import { SET_PRICE_GROUP } from '../actions/types';

const defaultState = {
    group: 'general'
}

export default (state = defaultState, action) => {
    switch (action.type) {
      case SET_PRICE_GROUP: return { ...state, group: action.payload };
    }

    return state;
}


// WEBPACK FOOTER //
// ./src/reducers/app.reducer.js